export default __webpack_public_path__ + "static/contact-icon-building-9ec959907e843d1734316b5ad914b5a2.png";